/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import { authContext } from '../../components/CognitoContextProvider/CognitoContextProvider'
import { LoginForm } from '../../components/LoginForm/LoginForm'

const Login = () => {
  const { signInWithGoogle } = useContext(authContext)

  const [loading, setLoading] = useState(false)

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true)
      await signInWithGoogle()
    } catch (err: any) {
      if (err.message === 'User is disabled.') {
        toast.error(
          'There was a problem logging in. Contact an administrator.',
          {
            toastId: 'user-disabled',
          },
        )
      } else {
        toast.error(
          'There was a problem starting Google sign in. Please try again.',
          {
            toastId: 'login-error',
          },
        )
      }
    }
    setLoading(false)
  }

  return (
    <>
      <Helmet>
        <title>Matrix Managed - Login</title>
      </Helmet>
      <main className="login-page">
        <div
          style={{
            height: '33vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/images/matrixmanaged-white.png"
            alt="MatrixManaged"
            className="login-page__logo"
          />
        </div>
        <div style={{ height: '33vh' }}>
          <LoginForm onGoogleSignIn={handleGoogleSignIn} loading={loading} />
        </div>
        <div style={{ height: '33vh' }}></div>
      </main>
    </>
  )
}

export default Login
